import './index.css'
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';

const KpopeNavbarComponent = () => {
    return (
      <>
        <Navbar className="color-nav" key={'md'} variant="light" expand={false} >
          <Container fluid>
            <div className="flexRowStart">
              <Navbar.Brand href="/">
                <img src={require('../../assets/kpope_logo.png')} width="150" alt=""/>
              </Navbar.Brand>
              <Navbar.Text variant="dark" style={{fontWeight:'normal', color:'black'}}>
                Digital Library
              </Navbar.Text>
            </div>
          </Container>
        </Navbar>
    </>  
     )
}

export const KpopeNavbar = () => {
  return (
    <>
      <KpopeNavbarComponent />
    </>
  )
}
